import { stringify } from 'qs';
import request from '../utils/request';

export async function getList(params) {
  return request(`/exchange/user-points?${stringify(params)}`);
}

export async function get(id, params = {}) {
  return request(`/exchange/user-points/${id}`, { params });
}

export async function create(body) {
  return request(`/exchange/user-points`, {
    method: 'POST',
    body,
  });
}

export async function update(id, body) {
  return request(`/exchange/user-points/${id}`, {
    method: 'POST',
    body,
  });
}